'use client';

import React, { useEffect } from 'react';
import DevClickOpener from '@repo/ui/src/components/DevClickOpener';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { usePathname } from 'next/navigation';
import { buildCanonicalUrl } from '@utils/buildCanonicalUrl';
import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import { trackPage, identifyUser } from '@repo/ui/src/services/analytics';

export interface TemplateProps {
  children: React.ReactNode;
}

gsap.registerPlugin(ScrollTrigger);

const Template = ({ children }: TemplateProps) => {
  const isProd = publicRuntimeConfig.appEnv === 'production';
  const pathname = usePathname();
  const canonicalUrl = buildCanonicalUrl(pathname ?? '');

  useEffect(() => {
    // Handle page tracking and user identification
    trackPage('Page', {
      url: canonicalUrl,
      path: pathname,
      referrer: document.referrer,
      brand: 'MEATER',
      timestamp: new Date().toISOString(),
    });

    const userEmail = typeof window !== 'undefined' ? localStorage.getItem('userEmail') : null;
    if (userEmail) {
      identifyUser(userEmail, {
        email: userEmail,
        brand: 'MEATER',
      });
    }
  }, [canonicalUrl, pathname]);

  useEffect(() => {
    // Dynamically import Braze SDK on the client side
    import('@braze/web-sdk')
      .then((braze) => {
        braze.initialize(
          publicRuntimeConfig.braze.appId || 'cfcc435c-0117-4f2d-97d9-b80e806894c5',
          {
            baseUrl: 'sdk.iad-05.braze.com',
            enableLogging: true,
            allowUserSuppliedJavascript: true,
          },
        );
        braze.automaticallyShowInAppMessages();
        braze.openSession();
      })
      .catch(() => {});
  }, []);

  return (
    <>
      {!isProd && <DevClickOpener hub="traegergrillsdev" />}
      {children}
    </>
  );
};

export default Template;
